import * as React from "react";
import { cn } from "@/lib/utils";
import { siteConfig } from "@/lib/seo/metadata";
import { CtaLink } from "@/shared/ui/cta-link";
import { HeroShell } from "@/shared/layout/HeroShell";

type ForClippingPlatformsHeroProps = React.HTMLAttributes<HTMLElement>;

export function ForClippingPlatformsHero({ className, ...props }: ForClippingPlatformsHeroProps) {
  return (
    <HeroShell className={className} {...props}>
      <div className="absolute left-1/2 top-[60%] flex w-full max-w-(--layout-hero-content-width) -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-6 px-6 text-center md:max-w-none">
        <h1 className="text-display-hero text-(--color-text-primary) md:whitespace-nowrap">For Clipping Platforms</h1>
        <p className="text-heading-sm text-(--color-text-primary)">Bring tier 1 brand campaigns to your clippers</p>
        <CtaLink
          analyticsElementId="for-clipping-platforms-hero:contact-cta"
          href={siteConfig.contact.calendly}
          target="_blank"
          rel="noopener noreferrer"
          className={cn("mt-2 px-8 md:mt-4")}
        >
          Contact Us
        </CtaLink>
      </div>
    </HeroShell>
  );
}
